import React from 'react';

const TermsOfService = ({ darkMode }) => {
  return (
    <div className={`terms-of-service ${darkMode ? 'dark' : ''}`}>
      <div className="legal-container">
        <h1>📋 Podmienky používania</h1>
        
        <div className="legal-section">
          <h2>🎯 O službe</h2>
          <p>
            Motivačné citáty je webová aplikácia určená na generovanie 
            inšpiratívnych citátov pomocou umelej inteligencie. 
            Služba je poskytovaná zadarmo s podporou reklám.
          </p>
        </div>

        <div className="legal-section">
          <h2>✅ Povolené použitie</h2>
          <ul>
            <li>Generovanie citátov pre osobné účely</li>
            <li>Zdieľanie citátov na sociálnych sieťach</li>
            <li>Ukladanie obľúbených citátov</li>
            <li>Export citátov do súborov</li>
            <li>Prihlásenie na odber emailov</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>❌ Zakázané použitie</h2>
          <ul>
            <li>Komerčné použitie bez povolenia</li>
            <li>Kopírovanie alebo klonovanik aplikácie</li>
            <li>Narušovanie funkcionality služby</li>
            <li>Automatizované získavanie obsahu (scraping)</li>
            <li>Zneužívanie na škodlivé účely</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>🤖 AI Generovaný obsah</h2>
          <p>
            Citáty sú generované pomocou umelej inteligencie (OpenAI GPT-4). 
            Obsah môže obsahovať nepresnosti a nie je garantovaná jeho správnosť. 
            Používatelia sú zodpovední za overenie a použitie obsahu.
          </p>
        </div>

        <div className="legal-section">
          <h2>📧 Email komunikácia</h2>
          <p>
            Prihlásením na odber súhlasíte s:
          </p>
          <ul>
            <li>Získavaním denných motivačných citátov</li>
            <li>Občasnými oznámeniami o nových funkciách</li>
            <li>Možnosťou odhlásiť sa kedykoľvek</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>📱 Mobilná aplikácia</h2>
          <p>
            Táto webová aplikácia je optimalizovaná pre mobilné zariadenia 
            a môže byť pridaná na domovskú obrazovku ako PWA (Progressive Web App).
          </p>
        </div>

        <div className="legal-section">
          <h2>🛡️ Obmedzenie zodpovednosti</h2>
          <p>
            Služba je poskytovaná "ako je" bez akýchkoľvek záruk. 
            Prevádzkovateľ nie je zodpovedný za:
          </p>
          <ul>
            <li>Presnosť generovaného obsahu</li>
            <li>Dostupnosť služby 24/7</li>
            <li>Stratu údajov alebo nastavení</li>
            <li>Škody vzniknuté používaním služby</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>🔄 Zmeny podmienok</h2>
          <p>
            Podmienky používania môžu byť upravené bez predchádzajúceho upozornenia. 
            Pokračovaním v používaní služby súhlasíte s aktuálnymi podmienkami.
          </p>
        </div>

        <div className="legal-section">
          <h2>📞 Kontakt</h2>
          <p>
            Pre otázky a pripomienky nás kontaktujte na:{' '}
            <a href="mailto:namotivujma@gmail.com">namotivujma@gmail.com</a>
          </p>
        </div>

        <div className="legal-section">
          <h2>⚖️ Rozhodné právo</h2>
          <p>
            Tieto podmienky sa riadia právnym poriadkom Slovenskej republiky. 
            Posledná aktualizácia: {new Date().toLocaleDateString('sk-SK')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
